<template>
    <div>
        <h4>เงื่อนไขและข้อกำหนดการขายสินค้าของเส้นด้าย</h4>
        <h5 class="pl-3">การกดยอมรับเงื่อนไขและข้อกำหนดนี้เป็นการยืนยันว่าร้านได้ตกลงและยินยอมปฏิบัติตามข้อตกลงดังต่อไปนี้</h5>
        <div v-for="(item , index) in conditionZendai.condition" :key="'C'+index" class="pl-3">
            <h5 v-html="item"></h5> 
        </div>
        <h4>ค่าตอบแทน</h4>
        <div v-for="(item , index) in conditionZendai.compensation" :key="'CP'+index" class="pl-3">
            <h5>{{item}}</h5> 
        </div>
        <h4>ระยะเวลาการขายสินค้า</h4>
        <div v-for="(item , index) in conditionZendai.period" :key="'P'+index" class="pl-3">
            <h5>{{item}}</h5> 
        </div>
    </div>
</template>

<script>
export default {
    name: "ConditionZendai" ,
    computed: {
        conditionZendai() {
            return {
                condition:[
                    '1. ร้านตกลงจัดหาที่ตั้งแสดงใบเมนูรายการสินค้าและ QR Code รับชำระเงินของเส้นด้ายไว้ ณ ที่เหมาะสม',
                    '2. การขายสินค้าแต่ละรายการต้องเป็นไปตามราคาที่กำหนดไว้ในใบเมนูรายการสินค้า',
                    '3. ร้านตกลงแจ้งข้อมูล สรุปยอดรายการการสินค้า และสลิปโอนเงินค่าสินค้าของลูกค้าแต่ละรายให้ชิปป๊อปทราบตามแบบฟอร์มที่กำหนดภายในวันสุดท้ายของแต่ละเดือน ทั้งนี้ในกรณีที่ร้านค้าแจ้งข้อมูลรายการการสินค้า หรือสลิปโอนเงินของลูกค้ารายใดไม่ครบถ้วนหรือไม่ชัดเจน ชิปป๊อปขอสงวนสิทธิในการปฏิเสธการชำระเงินค่าตอบแทนในรายการดังกล่าว',
                    '4. เมื่อชำระค่าสินค้าแล้วลูกค้าไม่สามารถนำไปลดหย่อนภาษี คืนสินค้าหรือนำมาแลกเปลี่ยนเป็นเงินสดได้',
                    '5. หากเกิดความผิดพลาด และ/หรือข้อโต้แย้งใดๆ ในใบเสร็จรับเงิน ลูกค้าจำเป็นต้องแจ้งความผิดพลาดนั้นให้ชิปป๊อปทราบภายใน 5 วัน นับจากวันที่ ออกใบเสร็จรับเงินดังกล่าว โดยชิปป๊อปจะไม่มีหน้าที่แก้ไขหรือพิจารณาข้อเรียกร้องใด ๆ ที่เกิดขึ้นหากลูกค้าแจ้งภายหลังจากระยะเวลาที่กำหนดในข้อ',
                    '6. ในกรณีที่มีการผิดเงื่อนไขและข้อกำหนดนี้ไม่ว่าทั้งหมดหรือบางส่วน หรือร้านก่อให้เกิดความเสียหายแก่ชิปป๊อปหรือเส้นด้าย ร้านตกลงยินยอมชดใช้บรรดาค่าเสียหายต่างๆ ที่เกิดขึ้นหรืออาจเกิดขึ้นในภายหลังให้แก่ฝ่ายที่เสียหายตามความเสียหายที่เกิดขึ้นจริงและสามารถใช้สิทธิฟ้องร้องเป็นคดีต่อศาลได้',
                ],
                period: [
                    '• ตั้งแต่ 11 ตุลาคม 2564 ถึง 30 เมษายน 2565 หรือจนกว่าจะมีประกาศเปลี่ยนแปลง'
                ],
                compensation: [
                    '• ร้านจะได้รับค่าตอบแทนร้อยละ 5 ของยอดขายสินค้าในแต่ละเดือน(รวมภาษีมูลค่าเพิ่มแล้ว) และมีการหักภาษีหัก ณ ที่จ่ายสำหรับค่าตอบแทนของแต่ละเดือน โดยชิปป๊อปจะชำระค่าบริการภายใน 45 วันหลังจากสรุปยอดและจะโอนค่าตอบแทนผ่านบัญชีที่แจ้งไว้กับชิปป๊อปเท่านั้น',
                    '• ค่าตอบแทนดังกล่าวจะชำระให้ต่อเมื่อมียอดตั้งแต่ 500 บาทขึ้นไป หากยังไม่ครบ 500 บาทจะชิปป๊อปชำระเงินให้ในรอบของเดือนถัดไปที่ยอดครบตามที่กำหนดหรือเมื่อสิ้นสุดระยะเวลาการขายสินค้า โดยร้านมีหน้าที่ออกใบเสร็จรับเงิน/ใบกํากับภาษี ส่งกลับมาให้แก่ชิปป๊อป ภายใน 15 วันหลังจากได้รับค่าตอบแทน'
                ]
            }
        }
    
    }
}
</script>